module.exports = __webpack_public_path__ + "static/media/genesys-down.d23fa6e2.png";